<template>
  <div class="news-notify">
    <div class="container">
      <div class="filter">
        <input
          class="input-search"
          placeholder="Nhập từ khóa tìm kiếm"
          v-model="searchText"
          @keyup.enter="handleSearch"
        />
        <app-button @click="handleSearch" :disabled="isLoading">
          Tìm kiếm
        </app-button>
      </div>
      <app-loading :loading="isLoading" />
      <div class="news-notify-list" ref="news-notify-list" v-if="!isLoading">
        <news-notify-auction-list :data="data" />
      </div>
      <div class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="totalPage"
          :page-range="5"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :page-link-class="'page-link-item'"
          :prev-class="'prev-item'"
          :prev-link-class="'prev-link-item'"
          :next-class="'next-item'"
          :next-link-class="'next-link-item'"
          :break-view-class="'break-view'"
          :break-view-link-class="'break-view-link'"
          prev-text="Trang trước"
          next-text="Trang sau"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2';

import News from '@/common/api/news';
import NewsNotifyAuctionList from '@/components/Dashboard/NewsNotifyAuctionList.vue';
import AppButton from '@/components/AppButton.vue';
import AppLoading from '@/components/AppLoading.vue';

export default {
  name: 'NewsNotifyPage',
  components: { NewsNotifyAuctionList, Pagination, AppButton, AppLoading },
  data() {
    return {
      data: [],
      page: 1,
      pageSize: 10,
      searchText: '',
      totalElements: 0,
      preSearchText: '',
      isLoading: false
    };
  },
  created() {
    this.getNewsNotify();
  },
  computed: {
    totalPage() {
      return Math.floor(this.totalElements / this.pageSize);
    }
  },
  watch: {
    page() {
      this.getNewsNotify();
    }
  },
  methods: {
    getNewsNotify() {
      this.isLoading = true;
      News.getNewsAuctionPaging({ pageSize: this.pageSize, pageIndex: this.page, keyword: this.searchText })
        .then(({ data }) => {
          if (data.Status === 200) {
            this.data = data.Data.Data;
            this.totalElements = data.Data.Total || 0;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleSearch() {
      if (this.preSearchText === this.searchText) {
        return;
      }
      this.page = 1;
      this.getNewsNotify();
      this.preSearchText = this.searchText;
    }
  }
};
</script>

<style>
.news-notify {
  margin-bottom: 12px;
}

.pagination-wrapper {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}

.filter {
  margin: 12px 0;
}

@media screen and (max-width: 600px) {
  .page-item,
  .prev-item,
  .next-item {
    max-width: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/NewsNotifyPage.vue